import type { MockedResponse } from "@apollo/client/testing";
import { COMMISSION_ACTIVITY_EVENTS_QUERY } from "../history/queries";
import type { CommissionActivityEventNode } from "../history/types";
import { buildConnection } from "./connection";
import { createCatalogMock, withTypenames, type MockResolver } from "./mockUtils";
import { runtimeActivityEvents } from "./runtimeState";

function buildActivityEventsMockData(variables: Record<string, unknown>) {
  const search = variables.search ? String(variables.search).toLowerCase() : "";
  const entityType = variables.entityType ? String(variables.entityType) : undefined;
  const entityId = variables.entityId ? String(variables.entityId) : undefined;

  const nodes = runtimeActivityEvents
    .filter((event) => {
      if (entityType && event.entityType !== entityType) return false;
      if (entityId && event.entityId !== entityId) return false;
      if (search) {
        const haystack = `${event.description} ${event.actorDisplayName}`.toLowerCase();
        if (!haystack.includes(search)) return false;
      }
      return true;
    })
    .map((event) => withTypenames(event, "BackofficeCommissionActivityEvent"));

  return {
    commissionActivityEvents: buildConnection("BackofficeCommissionActivityEventConnection", nodes)
  };
}

export function pushActivityEvent(
  entityType: CommissionActivityEventNode["entityType"],
  entityId: string,
  eventType: string,
  description: string
) {
  runtimeActivityEvents.unshift({
    id: `commission-activity-runtime-${runtimeActivityEvents.length + 1}`,
    entityType,
    entityId,
    eventType,
    description,
    actorDisplayName: "Finance Operator",
    occurredAt: new Date().toISOString()
  });
}

export const commissionActivityEventsApolloMock = createCatalogMock(
  COMMISSION_ACTIVITY_EVENTS_QUERY,
  buildActivityEventsMockData({})
);

export const historyApolloMocks: MockedResponse[] = [commissionActivityEventsApolloMock];

export const historyMockResults: Record<string, Record<string, unknown>> = {
  CommissionActivityEvents: buildActivityEventsMockData({})
};

export const historyVariableMockResolvers: Record<string, MockResolver> = {
  CommissionActivityEvents: (variables) => buildActivityEventsMockData(variables)
};
